export default "__VITE_ASSET__DPWypu3U__"